export const handleError = (e) => {
  return e instanceof Error ? e?.message : String(e);
};
